/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable import/no-extraneous-dependencies */
import React, { ReactElement, useState } from 'react';
import { Modal, ModalFooter } from 'reactstrap';
import classNames from 'classnames';
import Button from '../Button';
import Spinner from '../Spinner';
import { UNIT } from '../../constants';
import Checkbox from '../Checkbox';
import { checkAccess } from '../../utils/admins';


export type CheckboxOption = {
    id: string;
    text: string;
    disabled?: boolean;
    resetWhenDisabled?: boolean;
    onChange: (checked: boolean) => void;
};

export type ModalComponentProps = {
    color?: string,
    title?: string,
    message?: string,
    colored?: boolean,
    header?: boolean,
    showCancelBtn?: boolean,
    size?: string,
    width?: string,
    fixed?: boolean,
    modalBodyStyle?: React.CSSProperties,
    modalBodyClass?: string,
    modalFooterClass?: string,
    onClick?: React.MouseEventHandler<HTMLInputElement>,
    btnTxt?: string,
    children: any,
    handleClose?: any,
    isOpen?: boolean,
    btnColor?: string,
    padding?: string,
    loading?: boolean,
    subTitle?: string,
    showDeleteBtn?: boolean,
    checkedText?: boolean,
    handleDelete?: React.MouseEventHandler<HTMLInputElement>,
    btnDeleteTxt?: string,
    disabled?: boolean,
    checkboxes?: CheckboxOption[],
    showSecondaryBtn?: boolean,
    onSecondaryBtnClick?: React.MouseEventHandler<HTMLInputElement>,
    secondaryBtnText?: string,
    btnCloseTxt?: string,
    description?: string
}

export default function ModalComponent({
    color = 'primary',
    title,
    message,
    colored,
    header,
    showCancelBtn,
    size,
    width,
    fixed,
    modalBodyStyle,
    modalBodyClass,
    modalFooterClass,
    onClick,
    btnTxt = 'Ok',
    isOpen,
    children,
    handleClose,
    btnColor = 'primary',
    padding,
    checkedText = true,
    checkboxes = [],
    showSecondaryBtn,
    onSecondaryBtnClick,
    secondaryBtnText,
    loading, subTitle, showDeleteBtn, handleDelete, btnDeleteTxt, btnCloseTxt, description, disabled
}: ModalComponentProps) {
    const [checkboxStates, setCheckboxStates] = useState<Record<string, boolean>>({});
    const getIcon = (color: string): ReactElement | undefined => {
        let Icon: ReactElement | undefined;
        switch (color) {
            case 'primary':
            case 'success':
                Icon = <span className='lnr lnr-thumbs-up modal__title-icon' />;
                break;
            case 'warning':
                Icon = <span className='lnr lnr-flag modal__title-icon' />;
                break;
            case 'danger':
                Icon = <span className='lnr lnr-cross-circle modal__title-icon' />;
                break;
            default:
                Icon = undefined
                break;
        }
        return Icon;
    };

    const modalClass = classNames({
        'modal-dialog--colored': colored,
        'modal-dialog--header': header
    });

    const Icon = getIcon(color);

    const handleCheckboxClick = (id: string, onChange: (checked: boolean) => void) => {
        setCheckboxStates((prevState) => {
            const updatedState = { ...prevState };
            const newCheckedState = !prevState[id];
            updatedState[id] = newCheckedState;
            onChange(newCheckedState);
            const deletedOptions = Object.keys(prevState || {}).filter(
                (optionId) => !checkboxes?.some((option) => option?.id === optionId)
            );
            deletedOptions.forEach((optionId) => {
                delete updatedState[optionId];
            });
            checkboxes?.forEach((option) => {
                if (option.resetWhenDisabled && option.disabled && option.id in updatedState) {
                    updatedState[option.id] = false;
                }
            });
            return updatedState;
        });
    };

    const handleOnExit = () => {
        setCheckboxStates({});
    };
    return (
        <>
            {isOpen && (
                <Modal
                    isOpen={isOpen}
                    toggle={handleClose}
                    centered
                    onExit={handleOnExit}
                    size={size || 'md'}
                    modalClassName='ltr-support'
                    className={` modal-dialog--${color} ${modalClass || ''} `}
                    style={{ maxWidth: width }}
                >
                    <div className='modal-dialog--fixed' style={{ ...modalBodyStyle, borderRadius: UNIT }}>
                        <div className={`modal__header ${fixed ? 'modal__header--sticky' : ''} `}>
                            <button
                                className='lnr lnr-cross modal__close-btn'
                                type='button'
                                onClick={handleClose}
                            />
                            {header ? '' : Icon}
                            <h4 className='text-modal  modal__title'>{title}</h4>

                            {subTitle && (
                                <h6 style={{ fontSize: UNIT * 0.75 }} className="subtitle-selectable">{subTitle}</h6>
                            )}
                        </div>
                        <div
                            style={{ padding: padding === 'none' ? '0px' : '' }}
                            className={`modal__body my-2 ${modalBodyClass}`}
                        >
                            {description && <h4 className='mb-2' style={{ fontWeight: 600 }} >{description}</h4>}
                            {message || children}
                            {checkboxes?.length > 0 && (
                                checkboxes.map(({ id, text, disabled, onChange }, index) => (
                                    <Checkbox
                                        key={id}
                                        disabled={disabled ?? false}
                                        className="justify-content-start mt-3 py-2"
                                        value={checkboxStates?.[id] || false}
                                        name={`checkbox_${index}`}
                                        text={text}
                                        checkedText={checkedText}
                                        onClick={() => handleCheckboxClick(id, onChange)}
                                    />
                                ))
                            )}
                        </div>
                        <ModalFooter
                            className={`${fixed ? 'modal__footer--sticky' : ''} ${modalFooterClass} py-2`}
                            style={{
                                padding: 0,
                                paddingTop: '5px'
                            }}
                        >
                            {loading && (
                                <div className='row justify-content-center py-1'>
                                    <Spinner size={30} />
                                </div>
                            )}
                            {!loading && (
                                <div className='row justify-content-center  align-items-center py-1 px-0'>
                                    {showCancelBtn && (
                                        <Button
                                            color='secondary'
                                            text='Annuler'
                                            className='modal_cancel px-2'
                                            onClick={handleClose}
                                        >
                                            {btnCloseTxt || 'Retour'}
                                        </Button>
                                    )}
                                    {showDeleteBtn && (
                                        <Button
                                            color='danger'
                                            className='modal_cancel px-2'
                                            onClick={handleDelete}
                                        >
                                            {btnDeleteTxt}
                                        </Button>
                                    )}
                                    <Button
                                        className='modal_ok px-2'
                                        outline={colored}
                                        color={btnColor}
                                        disabled={disabled}
                                        onClick={onClick}
                                    >
                                        {btnTxt}
                                    </Button>
                                    {showSecondaryBtn && (
                                        <Button
                                            color='primary'
                                            className='modal_ok px-2'
                                            onClick={onSecondaryBtnClick}
                                        >
                                            {secondaryBtnText}
                                        </Button>
                                    )}
                                </div>
                            )}
                        </ModalFooter>
                    </div>
                </Modal>
            )}
        </>
    );
}